import { useState } from 'react';
import {Link, useNavigate} from 'react-router-dom';
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Separator } from "@/components/ui/separator";
import { authService } from '@/services/auth-service.js';
import StarrySkyBackground from "@/components/StarrySkyBackground";
import fantasyForest from "@/assets/fantasy_forest_big.jpg";
import googleSvg from "@/assets/svg/google_g.svg";


const SignInPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        try {
            await authService.login(email, password);
            navigate('/home');
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (error) {
            setError('Incorrect email or password');
        }
    };

    return (
        <div className="grid flex-col w-screen h-full place-items-center lg:flex-row">
            <div className="flex flex-col w-screen min-h-full lg:flex-row">
                <div className="relative hidden lg:flex lg:w-1/2">
                    <div className="flex items-center justify-center w-full h-full border-r-2 bg-input dark:bg-input dark:border-accent-foreground">
                        <img
                            src={fantasyForest}
                            alt="Sign In Illustration"
                            className="absolute object-fill w-full h-full"
                        />
                    </div>
                </div>

                <div className="flex items-center justify-center w-full p-6 lg:w-1/2 ">
                    <StarrySkyBackground showShootingStar={false} showAurora={false} showClouds={false} />
                    <div className="w-full max-w-md space-y-6">
                        <div className="space-y-2 text-center">
                            <h2 className="text-2xl font-bold text-foreground">Log in to your account</h2>
                            <p className="dark:text-neutral-50 hover:text-gray-900">
                                Don't have an account?{' '}
                                <Link to="/signup" className="text-white dark:text-primary hover:underline">
                                    Sign Up
                                </Link>
                            </p>
                        </div>

                        <form onSubmit={handleSubmit} className="space-y-4">
                            <div className="space-y-2">
                                <Label htmlFor="email" className="text-foreground">Email</Label>
                                <Input
                                    id="email"
                                    type="email"
                                    placeholder="Enter your email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </div>

                            <div className="space-y-2">
                                <Label htmlFor="password" className="text-foreground">Password</Label>
                                <Input
                                    id="password"
                                    type="password"
                                    placeholder="Enter your password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                            </div>

                            {error && (
                                <p className="text-sm text-center text-destructive">{error}</p>
                            )}

                            <Button
                                type="submit"
                                className="w-full bg-sky-100 hover:bg-sky-300"
                            >
                                Sign In
                            </Button>
                        </form>

                        <div className="flex items-center w-5/12 my-4 ml-1 lg:ml-3">
                            <Separator className="flex-grow bg-slate-900 dark:bg-slate-100" />
                            <span className="px-4">or</span>
                            <Separator className="flex-grow bg-slate-900 dark:bg-slate-100" />
                        </div>

                        <Button
                            variant="outline"
                            className="relative w-full bg-white dark:bg-black hover:bg-sky-300"
                            onClick={authService.handleGoogleAuth}
                        >
                            <img
                                src={googleSvg}
                                alt="Google Icon"
                                className="w-5 h-5 mr-2"
                            />
                            Continue with Google
                        </Button>

                        <div className="text-center">
                            <Link to="/forgot-password" className=" hover:underline">
                                Can't log in?
                            </Link>
                        </div>

                        <p className="mt-4 text-xs text-center text-foreground">
                            By continuing, you agree to our{' '}
                            <Link to="/terms" className="underline hover:text-foreground">Terms of Service</Link>{' '}
                            and{' '}
                            <Link to="/privacy" className="underline hover:text-foreground">Privacy Policy</Link>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SignInPage;
